import JSONEditor from 'jsoneditor';
import React, { useEffect, useRef } from 'react';
import 'jsoneditor/dist/jsoneditor.css';
export const TemplateJSONEditor = ({ values }) => {
    const container = useRef(null);
    const editorRef = useRef(null);
    useEffect(() => {
        if (!container.current) {
            return;
        }
        editorRef.current = new JSONEditor(container.current, {
            mode: 'view',
            sortObjectKeys: true
        });
    }, []);
    useEffect(() => {
        if (editorRef.current) {
            editorRef.current.update(values);
        }
    }, [values]);
    return (React.createElement("div", { className: "properties-editor", "data-cy": "properties-editor", ref: container, style: { width: '100%', height: '30em' } }));
};
